import { useNavigate, createSearchParams } from 'react-router-dom';

const useNavSearch = () => {
  const nav = useNavigate()
  return (pathName, params) =>
    nav( {pathname : pathName, search: `?${createSearchParams(params)}` })
};

export default useNavSearch;
